






















import Vue from 'vue';

export default Vue.extend({
  name: 'ToS',
  props: {
    mapImg: {
      type: Function,
      required: true,
    },
  },
});
